import Styles from './TreeItemIcon.module.scss'
import { MentionIcon } from 'components/MentionIcon/MentionIcon'
import { TreeDataItem, TreeItemType } from 'components/FilesTree/types'
import { ReactComponent as MembersIcon } from 'assets/icons/twoMembers16.svg'
import { externalFileEmoji } from 'components/ReviewsWizard/FileSelection/urlValidationUtils'
import { DocEmoji } from 'components/DocEmoji/DocEmoji'
import { Document, FolderClosed, Handbook } from 'almanac-ui/icons'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Folder, FolderOpen2 } from 'blaze-ui/icons'

interface Props {
  treeItem: TreeDataItem
  isExpanded?: boolean
}

const TreeItemIcon = ({ treeItem, isExpanded = false }: Props) => {
  const { type, header_emoji, external_file_icon, channel } = treeItem

  if (type === 'folder') return isExpanded ? <FolderOpen2 /> : <Folder />

  if (channel && !header_emoji) {
    return <ChannelIcon channel={channel} />
  }

  if (header_emoji || external_file_icon) {
    if (type === TreeItemType.Article) {
      return externalFileEmoji(treeItem) || <DocEmoji emoji={treeItem.header_emoji || null} />
    }

    return (
      <>
        {header_emoji}
        {treeItem.mention_id && treeItem.has_edit_access && <MentionIcon className={Styles.subIcon} />}
      </>
    )
  }

  if (type === TreeItemType.Article)
    return (
      <>
        <Document />
        {treeItem.mention_id && treeItem.has_edit_access && <MentionIcon className={Styles.subIcon} />}
      </>
    )

  if (type === TreeItemType.Channel) return <MembersIcon />
  if (type === TreeItemType.Handbook) return <Handbook />

  return isExpanded ? <Folder /> : <FolderClosed />
}

export { TreeItemIcon }
